module.exports = __webpack_public_path__ + "static/CLS_old-e11e73088e817295a071fcbe28f9c523.png";